import React, { useState } from 'react';
import { FolderPlus, X } from 'lucide-react';

import type { Projet } from '../../services/api/assistants';

interface Props {
  projets: Projet[];
  /** Numéro d'une activité existante, nom d'une activité à créer, ou rien. */
  valeur: number | string | null;
  onChange: (valeur: number | string | null) => void;
  /** Texte de l'option vide. Absent, l'activité n'est pas facultative. */
  optionVide?: string;
  desactive?: boolean;
}

/**
 * Choix d'une activité, avec création sur place.
 *
 * Sortir de l'écran pour créer l'activité puis y revenir fait perdre le fil,
 * surtout en séance. Le nom saisi ici est transmis tel quel au serveur, qui
 * crée l'activité au moment où il en a besoin : rien n'est créé si le dépôt
 * n'aboutit pas.
 */
const ChoixActivite: React.FC<Props> = ({
  projets, valeur, onChange, optionVide, desactive,
}) => {
  const [creation, setCreation] = useState(false);

  if (creation) {
    return (
      <div className="flex gap-2">
        <input
          autoFocus
          value={typeof valeur === 'string' ? valeur : ''}
          disabled={desactive}
          onChange={(e) => onChange(e.target.value)}
          placeholder="Ex. : Revue mensuelle PEV — Kankan"
          className="flex-1 rounded-md border border-[#DDE2DD] px-3 py-2 text-sm
            focus:border-eg-accent focus:outline-none"
        />
        <button
          type="button"
          title="Revenir à la liste"
          onClick={() => { setCreation(false); onChange(null); }}
          className="rounded-md border border-[#DDE2DD] px-2 text-eg-gris"
        >
          <X className="w-4 h-4" />
        </button>
      </div>
    );
  }

  return (
    <div className="flex gap-2">
      <select
        value={typeof valeur === 'number' ? valeur : ''}
        disabled={desactive}
        onChange={(e) => onChange(e.target.value ? Number(e.target.value) : null)}
        className="flex-1 rounded-md border border-[#DDE2DD] px-3 py-2 text-sm
          focus:border-eg-accent focus:outline-none"
      >
        <option value="">{optionVide || "Choisissez l'activité…"}</option>
        {projets.map((p) => <option key={p.id} value={p.id}>{p.name}</option>)}
      </select>
      <button
        type="button"
        onClick={() => { setCreation(true); onChange(''); }}
        disabled={desactive}
        className="inline-flex items-center gap-1 rounded-md border border-[#DDE2DD]
          px-3 py-2 text-sm text-eg-encre hover:border-eg-accent disabled:opacity-50"
      >
        <FolderPlus className="w-4 h-4" /> Nouvelle
      </button>
    </div>
  );
};

export default ChoixActivite;
